import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFilterContext } from '../../context/FilterContext'

interface iVariantsTabs {
  variants: { label: string; value: string }[]
}

const VariantsTabs = ({ variants }: iVariantsTabs) => {
  const { t } = useTranslation()
  const { variant, setVariant } = useFilterContext()

  return (
    <div className='gov-tabs__links-holder' role='tablist' aria-label='Varianty'>
      {variants.map(({ value, label }, index) => (
        <button
          key={index}
          id={'link-tab-' + value}
          className={'gov-tabs__link ' + (variant === value ? 'is-active' : '')}
          aria-selected='true'
          role='tab'
          onClick={(e) => setVariant(value)}
          aria-controls='link-0-tab'
          tabIndex={0}
        >
          {t(label, label)}
        </button>
      ))}
    </div>
  )
}

export default VariantsTabs
